export let folderDisplayName = "b9Epud";
export default {folderDisplayName};